export default "__VITE_ASSET__DMOxE6z8__"